<template>
    <div id="warranty_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area pt-0">
            <template v-if="cantAccessPage === true">
                <div class="page-name pb-1 warranty-create-header">
                    <span class="page-title" id="warrantyHeader" v-if="$route.params.id > 0">Update Warranty Claim</span>
                    <span class="page-title" id="warrantyHeader" v-else>Add Warranty Claim</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="backButton">
                        <i class="fp-back"></i> Back
                    </button>
                    <button v-if="showProcessBtn" type="submit" class="btn btn-primary pull-right"
                        style="margin-right: 5px;" v-on:click="startProcess">Start Process</button>
                    <div class="stepwizard" style="padding-top:5px">
                        <div class="stepwizard-row setup-panel">
                            <div class="stepwizard-step" v-for="step in steps" :key="step.id">
                                <a :href="step.href" @click.prevent="scrollTo(step.tab, step.id)"
                                    :class="buttonClass(step.id)" :id="step.stepId">{{ step.id }}</a>
                                <p class="mb-2">{{ step.label }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="padding-left: 2%;padding-right: 2%; margin-top: -25px;">
                        <div class="col-3"><b class="header-font">Claim Number</b>: {{ claimNumber }}</div>
                        <div class="col-3"><b class="header-font">VIN</b>: {{ vin }}</div>
                        <div class="col-4"><b class="header-font">Warranty Start Date</b>: {{ wsd }}</div>
                        <div class="col-2"><b class="header-font">Claim Status</b>: {{ claimStatus }}</div>
                    </div>
                </div>
                <div class="container-fluid mt-0">
                    <div class="admin-page-content warranty-create">
                        <section class="internal-container border-top-table-fl mt-1">
                            <warranty-claim-form-create 
                            ref="EvRef" 
                            @send-claim-number-to-parent="handleClaimNumber"
                            @send-vin-to-parent="handleVIN" 
                            @send-claim-status-to-parent="handleClaimStatus"
                            ></warranty-claim-form-create>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { commonMixins } from '../mixins/commonMixins';
import WarrantyClaimForm from "@/components/WarrantyClaimForm.vue";
import EVWarrantyClaimForm from "@/components/EVWarrantyClaimForm.vue";
import WarrantyClaimFormCreate from "./WarrantyClaimFormCreate.vue";

Vue.component("warranty-claim-form", WarrantyClaimForm);
Vue.component("ev-warranty-claim-form", EVWarrantyClaimForm);
Vue.component("warranty-claim-form-create", WarrantyClaimFormCreate);

export default {
    name: "WarrantyCreate",
    metaInfo() {
      return {
        title: (this.isEditPage == true) ? "Warranty Claim Update | " + process.env.COPYRIGHT_NAME : "Warranty Claim Create | " +process.env.COPYRIGHT_NAME
      }
    },
    mixins: [commonMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: "",
        loading: false,
        velocity_env: process.env.NODE_ENV,
        activeStep: 1,
        claimNumber: '',
        vin: '',
        wsd: '',
        steps: [
            { id: 1, href: '#step-1', tab: 'claimTab', stepId: 'step1', label: 'Claim Header' },
            { id: 2, href: '#step-2', tab: 'failureTab', stepId: 'step2', label: 'Repair Details' },
            { id: 3, href: '#step-3', tab: 'laborTab', stepId: 'step3', label: 'Labor' },
            { id: 4, href: '#step-4', tab: 'partTab', stepId: 'step4', label: 'Parts' },
            { id: 5, href: '#step-5', tab: 'otherChargeTab', stepId: 'step5', label: 'Other Charges' },
            { id: 6, href: '#step-6', tab: 'attachmentTab', stepId: 'step6', label: 'Attachments' },
            { id: 7, href: '#step-7', tab: 'summaryTab', stepId: 'step7', label: 'Summary' }
        ],
        claimStatus: '',
        showProcessBtn: false,
        canViewAllFields: false,
        bypassConfirmation: false, // Flag to bypass confirmation dialogs
        isEditPage: false
    }),
    beforeRouteLeave(to, from, next) {        
        if(this.cantAccessPage){
            this.$refs.EvRef.clearButtonFocus();
        }
        if (this.bypassConfirmation || !this.$refs.EvRef.handleFormFieldsChanges()) {
            next();
        } else {
            if (confirm("Changes you made may not be saved.")) {
                next(); // Proceed with navigation
            } else {
                next(false); // Cancel navigation
            }
        }
    },
    watch: {
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (self.velocity_env == 'velev' || self.velocity_env == 'velev_test') {
                        if(self.isEditPage){
                            if (permissions[i].name == 'ev_edit_claim') {
                                self.cantAccessPage = true;
                            }
                        }else{
                            if (permissions[i].name == 'ev_add_claim') {
                                self.cantAccessPage = true;
                            }
                        }
                        if (permissions[i].name == 'ev_view_all_form_fields') {
                            self.canViewAllFields = true;
                        }
                    } else {
                        if (permissions[i].name == 'add_warranty') {
                            self.cantAccessPage = true;
                        }
                    }
                }
            }
            if(!self.cantAccessPage){
                self.handleButtonClick();
            }
        }
    },
    created() {
        window.addEventListener('beforeunload', this.beforeWindowUnload);
        this.$root.$on('WarrantyClaimLoadingStatusChanged', this.updateLoadingStatus);
    },
    mounted: function () {
        var self = this;
        if (self.$route.params.id > 0) {
            self.isEditPage = true;
        }
        self.getPermissions();
        window.addEventListener('scroll', this.onScroll);
        self.$nextTick(() => {
            const laborStep = self.steps.find(col => col.tab === 'laborTab');
            if (laborStep) {
                laborStep.label = self.labor_spelling;
            }
        });
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload)
        window.removeEventListener('scroll', this.onScroll);
        this.$root.$off('WarrantyClaimLoadingStatusChanged', this.updateLoadingStatus);;
    },
    methods: {
        updateLoadingStatus(status) {            
            this.loading = status;
        },
        beforeWindowUnload(event) {
            if (this.bypassConfirmation || this.$refs.EvRef.handleFormFieldsChanges()) {
                event.preventDefault();
                event.returnValue = '';
            }       
        },
        onScroll() {
            const sections = [
                'claimTab',
                'failureTab',
                'laborTab',
                'partTab',
                'otherChargeTab',
                'attachmentTab',
                'summaryTab'
            ];
            var fixedHeaderHeight = document.querySelector('.page-name').offsetHeight || 0;
            fixedHeaderHeight = fixedHeaderHeight + 150;
            let currentSection = null;

            for (let i = 0; i < sections.length; i++) {
                const section = this.$refs.EvRef.$refs[sections[i]];
                if (section) {
                    const rect = section.$el.getBoundingClientRect();
                    if (rect.top - fixedHeaderHeight <= 0 && rect.bottom - fixedHeaderHeight > 0) {
                        currentSection = i + 1;
                        break;
                    }
                }
            }

            if (currentSection !== null) {
                this.activeStep = currentSection;
            }
        },
        scrollTo(refName, stepNumber) {
            const fixedHeaderHeight = document.querySelector('.page-name').offsetHeight || 0;
            this.$refs.EvRef.scrollTo(refName, fixedHeaderHeight);
            this.activeStep = stepNumber;
        },
        buttonClass(stepNumber) {
            return {
                'btn': true,
                'btn-circle': true,
                'btn-primary': this.activeStep === stepNumber,
                'btn-tertiary': this.activeStep !== stepNumber
            };
        },
        handleClaimNumber(claimNumberData) {
            this.claimNumber = claimNumberData.claimNumber;
        },
        handleVIN(vinData) {
            this.vin = vinData.vin;
            this.wsd = vinData.wsd;
        },
        handleClaimStatus(claimStatus) {
            this.claimStatus = claimStatus;
            this.checkIfProcessBtn();
        },
        checkIfProcessBtn() {
            if (this.canViewAllFields) {
                if (
                    this.claimStatus == "Deleted"
                    ||
                    this.claimStatus == "Open"
                    ||
                    this.claimStatus == "Corrections Made/Dealer Response"
                ) {
                    this.showProcessBtn = true;
                }else{
                    this.showProcessBtn = false;
                }
            }

        },
        backButton() {
            this.$refs.EvRef.redirectBackUrl();
        },
        startProcess() {
            this.$refs.EvRef.startProcessWarrantyClaim();
        },
        handleButtonClick(){
            // Set the flag to bypass the confirmation dialog
            this.bypassConfirmation = true;
        },
    }
};
</script>

<style scoped>
.stepwizard .stepwizard-row {
    display: flex;
    justify-content: space-between;
    position: relative;
    width: 100%;
}

.stepwizard .stepwizard-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    text-align: center;
    position: relative;
}

.container-fluid {
    background-color: white;
}

.header-font {
    font-size: 18px;
}

.warranty-create-header {
    position: sticky;
    top: 65px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/WarrantyClaimCreate.vue